import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import { useRecurringGifts } from "../../RecurringGiftsContext";

export default function ValidationMessage() {
  const { state } = useRecurringGifts();
  const { editPanelValidationError } = state.editModal;

  const getMessage = () => {
    switch (editPanelValidationError) {
      case null:
        return "";
      case "amount":
        return "Please enter an amount greater than $2.";
      case "interval":
        return "Please select an interval for your gift.";
      case "startDate":
        return "Please select a date for your first gift.";
      case "paymentMethod":
        return "Please select the payment method you'd like to use.";
      case "today":
        return `Please note that this first payment will process immediately upon clicking the Save button below.`;
      case "isUnusable":
        return "Your payment method needs to be updated before you can update this recurring gift.";
      default:
        return "";
    }
  };

  return (
    <AnimatePresence>
      {editPanelValidationError ? (
        <Wrapper
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
        >
          <div style={{ height: 10 }} />
          {getMessage()}
          <div style={{ height: 10 }} />
        </Wrapper>
      ) : null}
    </AnimatePresence>
  );
}

const Wrapper = styled(motion.div)`
  overflow: hidden;
  background-color: #f7f0b6;
  color: #ad8114;
  font-weight: 400;
  padding: 0 14px;
  border-radius: 10px;
  margin-bottom: 20px;
`;
